'use client';

import {motion} from 'framer-motion';
import {cn} from '../../lib/utils';

const DURATION = 2;

interface LoaderProps {
  sx?: React.CSSProperties;
  style?: React.CSSProperties;
  className?: string;
}

const Loader = ({sx, style, className}: LoaderProps) => {
  const combinedStyle = {
    ...sx,
    ...style
  };

  return (
    <div
      className={cn('flex items-center justify-center py-6', className)}
      style={combinedStyle}
    >
      <motion.div
        animate={{
          scale: [0.8, 1, 0.8],
          opacity: [0.8, 1, 0.8]
        }}
        transition={{
          duration: DURATION,
          ease: 'easeInOut',
          times: [0, 0.2, 1],
          repeat: Infinity
        }}
        className="m-auto"
      >
        <svg
          width="226"
          height="180"
          viewBox="0 0 226 180"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M92.3911 95.6834C95.5841 92.534 97.457 85.377 97.457 85.377L103.047 105.926C103.047 105.926 95.3736 104.871 91.1683 106.863C86.6911 108.984 82.6145 116.232 82.6145 116.232L80.1011 100.708C80.1011 100.708 88.6995 99.3247 92.3911 95.6834Z"
            fill="url(#paint0_linear_4055_6419)"
          />
          <path
            d="M105.318 45.0212C110.2 42.1215 113.703 33.1426 113.703 33.1426L124.184 48.4738C124.184 48.4738 112.626 49.5832 107.938 54.4543C105.038 57.4671 102.872 63.8873 102.872 63.8873L94.8364 47.4668C94.8364 47.4668 101.704 47.1676 105.318 45.0212Z"
            fill="url(#paint1_linear_4055_6419)"
          />
          <path
            d="M127.5 107.181C130.487 108.783 136.06 108.608 136.06 108.608L126.103 118.915C126.103 118.915 124.058 112.293 120.76 109.831C117.725 107.565 111.429 107.181 111.429 107.181L120.76 98.4764C120.76 98.4764 123.711 105.15 127.5 107.181Z"
            fill="url(#paint2_linear_4055_6419)"
          />
          <path
            d="M104.094 77.5143C106.841 79.5718 112.573 79.82 112.573 79.82L102.616 90.1265C102.616 90.1265 100.39 83.9697 97.2817 81.5321C94.254 79.1578 87.9426 78.3931 87.9426 78.3931L99.3779 69.1294C99.3779 69.1294 101.088 75.2616 104.094 77.5143Z"
            fill="url(#paint3_linear_4055_6419)"
          />
          <path
            d="M147.591 50.612C149.914 53.1183 155.452 54.4551 155.452 54.4551L139.556 62.84C139.556 62.84 140.823 56.3323 138.682 53.2323C136.132 49.5394 127.852 49.3892 127.852 49.3892L144.38 41.5922C144.38 41.5922 145.05 47.8695 147.591 50.612Z"
            fill="url(#paint4_linear_4055_6419)"
          />
          <g filter="url(#filter0_d_4055_6419)">
            <circle cx="109.858" cy="93.4069" r="14.8483" fill="#4C545F" />
          </g>
          <g filter="url(#filter1_d_4055_6419)">
            <circle cx="67.2356" cy="107.387" r="17.6433" fill="#353E4B" />
          </g>
          <g filter="url(#filter2_d_4055_6419)">
            <circle cx="139.554" cy="122.059" r="14.8483" fill="#4C545F" />
          </g>
          <g filter="url(#filter3_d_4055_6419)">
            <circle cx="84.355" cy="63.0132" r="19.3902" fill="#1F2937" />
          </g>
          <g filter="url(#filter4_d_4055_6419)">
            <circle cx="131.346" cy="33.8412" r="18.1674" fill="#353E4B" />
          </g>
          <g filter="url(#filter5_d_4055_6419)">
            <circle cx="159.471" cy="78.5614" r="26.0282" fill="#1F2937" />
          </g>
          <defs>
            <filter
              id="filter0_d_4055_6419"
              x="78.1348"
              y="67.3086"
              width="63.4467"
              height="63.4472"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_4055_6419"
              x="32.7173"
              y="78.4942"
              width="69.0366"
              height="69.0371"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_d_4055_6419"
              x="107.831"
              y="95.961"
              width="63.4467"
              height="63.4472"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <filter
              id="filter3_d_4055_6419"
              x="48.0899"
              y="32.3731"
              width="72.5302"
              height="72.5312"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <filter
              id="filter4_d_4055_6419"
              x="96.3032"
              y="4.42385"
              width="70.0844"
              height="70.0839"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <filter
              id="filter5_d_4055_6419"
              x="116.567"
              y="41.2832"
              width="85.8066"
              height="85.8066"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="5.62499" />
              <feGaussianBlur stdDeviation="8.43749" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.298039 0 0 0 0 0.329412 0 0 0 0 0.372549 0 0 0 0.48 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_4055_6419"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_4055_6419"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_4055_6419"
              x1="98.4964"
              y1="96.5014"
              x2="81.7487"
              y2="102.645"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1F2937" stopOpacity="0.2" />
              <stop offset="1" stopColor="#1F2937" stopOpacity="0.6" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_4055_6419"
              x1="118.364"
              y1="44.2272"
              x2="98.4714"
              y2="53.5932"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1F2937" stopOpacity="0.2" />
              <stop offset="1" stopColor="#1F2937" stopOpacity="0.6" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_4055_6419"
              x1="129.393"
              y1="112.828"
              x2="117.417"
              y2="102.895"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1F2937" stopOpacity="0.2" />
              <stop offset="1" stopColor="#1F2937" stopOpacity="0.6" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_4055_6419"
              x1="105.938"
              y1="84.1092"
              x2="94.2158"
              y2="74.2427"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1F2937" stopOpacity="0.2" />
              <stop offset="1" stopColor="#1F2937" stopOpacity="0.6" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_4055_6419"
              x1="151.521"
              y1="52.5335"
              x2="135.626"
              y2="60.9184"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1F2937" stopOpacity="0.2" />
              <stop offset="1" stopColor="#1F2937" stopOpacity="0.6" />
            </linearGradient>
          </defs>
        </svg>
      </motion.div>
    </div>
  );
};

export default Loader;
export {Loader};
